import * as R from 'ramda'

export function getCountries(state) {
  return state
}

export function getCountry(state, countryCode) {
  return R.find(R.propEq('alpha2', countryCode), state)
}
